import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const PINK = [255, 0, 127];
const DARK = [5, 5, 7];
const MUTED = [110, 110, 125];

export function generateReportPdf(report) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const fmt = (n) => (typeof n === "number" ? n.toLocaleString("it-IT") : n);
  const ins = report.insurance || {};
  const rcaOk = ins.has_insurance && ins.compliant && !ins.suspended;

  doc.setFillColor(...DARK);
  doc.rect(0, 0, W, 118, "F");
  doc.setFillColor(...PINK);
  doc.rect(40, 30, 26, 26, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("VERITARGA", 78, 48);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(0, 240, 255);
  doc.text("REGISTRO VEICOLI ITALIA — REPORT TECNICO CERTIFICATO", 78, 62);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(30);
  doc.setTextColor(255, 255, 255);
  doc.text(report.targa, 40, 100);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...MUTED);
  doc.text(
    `${report.brand} ${report.model}  ·  Generato il ${new Date().toLocaleDateString("it-IT")}`,
    40,
    136
  );

  const margin = { left: 40, right: 40 };
  const baseStyles = { fontSize: 9, cellPadding: 5 };
  const labelCol = { 0: { cellWidth: 170, textColor: MUTED } };

  autoTable(doc, {
    startY: 156,
    theme: "grid",
    head: [["ANAGRAFICA VEICOLO", ""]],
    headStyles: { fillColor: [...DARK], fontStyle: "bold", fontSize: 10 },
    body: [
      ["Marca", report.brand],
      ["Modello", report.model],
      ...(report.trim ? [["Allestimento", report.trim]] : []),
      ["Immatricolazione", String(report.registration)],
      ...(report.registration_place ? [["Luogo Immatricolazione", report.registration_place]] : []),
      ...(report.vin ? [["Numero Telaio (VIN)", report.vin]] : []),
      ["Tipologia", report.vehicle_type || "Automobile"],
      ...(report.body && report.body !== "N/D" ? [["Carrozzeria", report.body]] : []),
    ],
    styles: baseStyles,
    columnStyles: labelCol,
    margin,
  });

  autoTable(doc, {
    theme: "grid",
    head: [["DATI MOTORE & ALLESTIMENTO", ""]],
    headStyles: { fillColor: [...DARK], fontStyle: "bold", fontSize: 10 },
    body: [
      ["Cilindrata", `${fmt(report.engine_displacement_cc)} cc`],
      ["Potenza", `${report.power_cv} CV`],
      ["Alimentazione", String(report.fuel)],
      ["Classe Emissioni", String(report.euro_class)],
    ],
    styles: baseStyles,
    columnStyles: labelCol,
    margin,
  });

  autoTable(doc, {
    theme: "grid",
    head: [["Anno", "Chilometraggio"]],
    headStyles: { fillColor: [...PINK], fontStyle: "bold", fontSize: 10 },
    body: (report.mileage_history || []).map((m) => [String(m.year), `${fmt(m.km)} km`]),
    styles: baseStyles,
    columnStyles: { 0: { cellWidth: 170, textColor: MUTED } },
    margin,
    didDrawPage: () => {},
    willDrawPage: () => {},
  });

  if ((report.revisions || []).length > 0) {
    autoTable(doc, {
      theme: "grid",
      head: [["Anno", "Chilometraggio", "Esito", "Centro di Revisione"]],
      headStyles: { fillColor: [...DARK], fontStyle: "bold", fontSize: 10 },
      body: report.revisions.map((r) => [
        String(r.year),
        `${fmt(r.km)} km`,
        r.esito,
        r.station || "-",
      ]),
      styles: baseStyles,
      columnStyles: { 0: { cellWidth: 60, textColor: MUTED }, 1: { cellWidth: 110, textColor: MUTED } },
      margin,
    });
  }

  autoTable(doc, {
    theme: "grid",
    head: [["STATO RCA & ASSICURAZIONE", ""]],
    headStyles: { fillColor: [...DARK], fontStyle: "bold", fontSize: 10 },
    body: [
      ["Stato RCA", rcaOk ? "ATTIVA" : "NON ATTIVA"],
      ["Compagnia", String(ins.insurer || "-")],
      ["N. Polizza", String(ins.policy_number || "-")],
      ["Scadenza Polizza", String(ins.policy_expiry || "-")],
      ["Copertura fino al", String(ins.coverage_expiry || "-")],
    ],
    styles: baseStyles,
    columnStyles: labelCol,
    margin,
  });

  const pages = doc.getNumberOfPages();
  for (let i = 1; i <= pages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(...MUTED);
    doc.text(
      `VeriTarga · Pagamenti sicuri gestiti da Stripe · Pagina ${i}/${pages}`,
      40,
      doc.internal.pageSize.getHeight() - 24
    );
  }

  doc.save(`VeriTarga_${report.targa}.pdf`);
}
